import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const blobsEndFromTrigger = "5300px top";

gsap.registerPlugin(ScrollTrigger);
ScrollTrigger.saveStyles("#agency, #consultancy,#gradient--light,#gradient--light-2,#plus,#gradient--red--left,#gradient--red--right,#logo,#logo-text,#impossible,#done")

ScrollTrigger.matchMedia({
  "(min-width:992px)": function () {
    //agency
    const tl1 = gsap.timeline({
      scrollTrigger: {
        trigger: "#trigger",
        start: "top 50%",
        endTrigger: "#trigger",
        end: blobsEndFromTrigger,
        pin: "#agency",
        scrub: 1,
        invalidateOnRefresh: true
      },
    });

    tl1
      .to("#agency", { x: 0, opacity: 1, duration: 1.5 })
      .to("#agency", { x: 0, opacity: 1, duration: 0.5 })
      .to("#agency", { x: "-100vh", opacity: 1, duration: 2 });

    //consultancy
    const tl2 = gsap.timeline({
      scrollTrigger: {
        trigger: "#trigger",
        start: "top 50% ",
        endTrigger: "#trigger",
        end: blobsEndFromTrigger,
        pin: "#consultancy",
        scrub: 1,
        invalidateOnRefresh: true
      },
    });

    tl2
      .to("#consultancy", { x: 0, opacity: 1, duration: 1.5 })
      .to("#consultancy", { x: 0, opacity: 1, duration: 0.5 })
      .to("#consultancy", { x: "100vh", opacity: 1, duration: 2 });

    // light blob left
    gsap.from("#gradient--light", { scale: 0, opacity: 0, duration: 1 });

    const tl3 = gsap.timeline({
      scrollTrigger: {
        trigger: "#gradient--light",
        start: "center center",
        endTrigger: "#trigger",
        end: blobsEndFromTrigger,
        pin: "#gradient--light",
        scrub: 1,
        invalidateOnRefresh: true
      }
    });

    tl3
      .to("#gradient--light", { duration: 2 })
      .to("#gradient--light", { x: "-100vw", duration: 2 });

    // light blob right
    gsap.from("#gradient--light-2", { scale: 0, opacity: 0, duration: 1 });

    const tl4 = gsap.timeline({
      scrollTrigger: {
        trigger: "#gradient--light-2",
        start: "center center",
        endTrigger: "#trigger",
        end: blobsEndFromTrigger,
        pin: "#gradient--light-2",
        scrub: 1,
        invalidateOnRefresh: true
      },
    });

    tl4
      .to("#gradient--light-2", { duration: 2 })
      .to("#gradient--light-2", { x: "100vw", duration: 2 });

    const tl11 = gsap.timeline({
      scrollTrigger: {
        trigger: "#trigger",
        start: "top 55% ",
        end: "+=5000 ",
        pin: "#plus",
        scrub: 1,
        invalidateOnRefresh: true
      },
    });
    tl11
      .to("#plus", { x: "-10vh", opacity: 0, duration: 1 })
      .to("#plus", { x: "0vh", opacity: 1, duration: 2.5 })
      .to("#plus", { x: "0vh", opacity: 1, duration: 0.5 })
      .to("#plus", { x: "-10vh", opacity: 0, duration: 2 })
      .to("#plus", { x: "-100vh", opacity: 0, duration: 2 });

    const tl5 = gsap.timeline({
      scrollTrigger: {
        trigger: "#trigger",

        start: "top 50% ",
        end: "+=6000 ",
        pin: "#gradient--red--left",
        scrub: 1,
        invalidateOnRefresh: true
      },
    });

    tl5
      .to("#gradient--red--left", { x: 0, opacity: 1, duration: 500 })
      .to("#gradient--red--left", { x: 0, opacity: 1, duration: 500 })
      .to("#gradient--red--left", {
        x: 0,
        opacity: 1,
        scale: 1.2,
        duration: 500,
      })
      .to("#gradient--red--left", {
        x: "0",
        opacity: 1,
        scale: 1.8,
        duration: 500,
      });
    const tl6 = gsap.timeline({
      scrollTrigger: {
        trigger: "#trigger",

        start: "top 50% ",
        end: "+=6000  ",
        pin: "#gradient--red--right",
        scrub: 1,
      },
    });

    tl6
      .to("#gradient--red--right", { x: 0, opacity: 1, duration: 500 })
      .to("#gradient--red--right", { x: 0, opacity: 1, duration: 500 })
      .to("#gradient--red--right", {
        x: 0,
        opacity: 1,
        scale: 1.2,
        duration: 500,
      })
      .to("#gradient--red--right", {
        x: "0",
        opacity: 1,
        scale: 1.8,
        duration: 500,
      });

    const tl20 = gsap.timeline({
      scrollTrigger: {
        trigger: "#trigger",
        start: "top 35% ",
        end: "+=6000  ",
        pin: "#logo",
        pinSpacing: false,
        scrub: 1,
      },
    });

    tl20
      .to("#logo", { scale: 0, opacity: 0, y: "200px", duration: 750 })
      .to("#logo", { opacity: 1, scale: 0.5, y: "200px", duration: 250 })
      .to("#logo", { scale: 1, duration: 200, y: "0px" })
      .to("#logo", { scale: 1, duration: 200 });

    const tl8 = gsap.timeline({
      scrollTrigger: {
        trigger: "#trigger",
        invalidateOnRefresh: true,
        start: "top 37% ",
        end: "+=6000  ",
        pin: "#logo-text",
        pinSpacing: false,
        scrub: 1,
      },
    });

    tl8
      .to("#logo-text", { opacity: 0, y: "200px", duration: 2200 })
      .to("#logo-text", { opacity: 0, y: "200px", duration: 500 })
      .to("#logo-text", { opacity: 1, y: "0px", duration: 200 })
      .to("#logo-text", { opacity: 1, duration: 200 });

    const tl9 = gsap.timeline({
      x: "-100%",
      scrollTrigger: {
        trigger: "#trigger",
        start: "top 35% ",
        end: "+=6000 ",
        pin: "#impossible",
        pinSpacing: false,
        scrub: 1,
      },
    });

    tl9
      .to("#impossible", { opacity: 0, x: "-100%", duration: 5000 })
      .to("#impossible", {
        opacity: 0,
        x: "-100%",

        duration: 1000,
      })
      .to("#impossible", {
        opacity: 1,
        x: "0",

        duration: 1000,
      });

    const tl10 = gsap.timeline({
      x: "-100%",
      scrollTrigger: {
        trigger: "#trigger",
        start: "top 35% ",
        end: "+=6000  ",
        pin: "#done",
        pinSpacing: false,
        scrub: 1,
        invalidateOnRefresh: true
      },
    });
    tl10
      .to("#done", { opacity: 0, x: "100%", duration: 5000 })
      .to("#done", { opacity: 0, x: "100%", duration: 1000 })
      .to("#done", { opacity: 1, x: "0", duration: 1000 });
  },

  "(max-width:991px)": function () {
    agency;
    const tl1 = gsap.timeline({
      scrollTrigger: {
        trigger: "#trigger",
        start: "top 40% ",
        end: "+=1000 ",
        pin: "#agency",
        scrub: 1,
        invalidateOnRefresh: true
      },
    });

    tl1.from("#agency", { x: 0, opacity: 1, duration: 1 });
    tl1.to("#agency", { x: "-100vw", opacity: 1, duration: 5 });

    //consultancy
    const tl2 = gsap.timeline({
      scrollTrigger: {
        trigger: "#trigger",
        invalidateOnRefresh: true,
        start: "top 40% ",
        end: "+=1000 ",
        pin: "#consultancy",
        scrub: 1,
      },
    });

    tl2
      .from("#consultancy", { x: 0, opacity: 1, duration: 1 })
      .to("#consultancy", { x: "100vw", opacity: 1, duration: 5 });
    const tl11 = gsap.timeline({
      scrollTrigger: {
        trigger: "#trigger",
        start: "top 40% ",
        end: "+=1000 ",
        pin: "#plus",
        scrub: 1,
        invalidateOnRefresh: true
      },
    });
    tl11
      .from("#plus", { x: 0, opacity: 1, duration: 1 })
      .to("#plus", { x: "-100vw", opacity: 0, duration: 5 });

    const tl5 = gsap.timeline({
      scrollTrigger: {
        trigger: "#trigger",
        invalidateOnRefresh: true,
        start: "top 40% ",
        end: "+=1500 ",
        pin: "#gradient--red--left",
        scrub: 1,
      },
    });

    const tl7 = gsap.timeline({
      scrollTrigger: {
        trigger: "#trigger",
        invalidateOnRefresh: true,
        start: "top 20% ",
        end: "+=1500  ",
        pin: "#logo",
        scrub: 1,

        opacity: 1,
        scale: 0,
      },
    });
    tl7
      .to("#logo", { scale: 0, opacity: 0, y: "200px", duration: 3 })
      .to("#logo", { opacity: 1, scale: 0.4, y: "200px", duration: 2 })
      .to("#logo", { scale: 0.7, y: "0px", duration: 1 })
      .to("#logo", { scale: 0.7, duration: 1 });

    const tl8 = gsap.timeline({
      scrollTrigger: {
        trigger: "#trigger",
        start: "top 20% ",
        end: "+=1500  ",
        pin: "#logo-text",
        pinSpacing: false,
        scrub: 1,
        invalidateOnRefresh: true
      },
    });

    tl8
      .to("#logo-text", { opacity: 0, yPercent: "200", duration: 3 })
      .to("#logo-text", { opacity: 0, yPercent: "200", duration: 2 })
      .to("#logo-text", { opacity: 1, yPercent: "50", duration: 1 })
      .to("#logo-text", { duration: 2, yPercent: "20", duration: 1 });

    const tl9 = gsap.timeline({
      x: "-100%",

      scrollTrigger: {
        trigger: "#trigger",
        start: "top 20% ",
        end: "+=1500  ",
        pin: "#impossible",
        pinSpacing: false,
        scrub: 1,
        invalidateOnRefresh: true
      },
    });

    tl9
      .to("#impossible", { opacity: 0, x: "-100%", delay: 5 })
      .to("#impossible", {
        opacity: 0,
        x: "-100%",
      })
      .to("#impossible", {
        opacity: 1,
        x: "0",
      });

    const tl10 = gsap.timeline({
      x: "-100%",
      scrollTrigger: {
        trigger: "#trigger",
        start: "top 20% ",
        end: "+=1500  ",
        pin: "#done",
        pinSpacing: false,
        invalidateOnRefresh: true,
        scrub: 1,
      },
    });
    tl10
      .to("#done", { opacity: 0, x: "100%", delay: 5 })
      .to("#done", { opacity: 0, x: "100%" })
      .to("#done", { opacity: 1, x: "0" });
  },
});
